import React from 'react';

const SectionCourse = ({ content }) => {
  const course =
    this.props.courses &&
    this.props.courses.find(
      (course) => course.id === content.referenced_course_id
    );

  if (!course) {
    return 'コースデータがありません';
  }

  return (
    <div className="d-flex">
      <img
        className=""
        type="image"
        src={course.main_image_small}
        height="64px"
      />
      <p>コース名：{course.title}</p>
    </div>
  );
};

export default SectionCourse;
